import $ from 'jquery';
import Cookies from 'js-cookie';
import CsrfToken from '../csrf/Csrf';
import { 
    ProductTypeEnum 
} from '../../enums/ProductTypeEnum';
import {ProductFetcher} from "../../../../../../ReactApp/Services/ProductFetcher/ProductFetcher";
import {biMarketingEventRunnerRun} from "../bi/WithBiMarketingEventRunner";
import {MarketingEventTypeEnum} from "../../enums/MarketingEventTypeEnum";
import {MarketingEventVariableTypeEnum} from "../../enums/MarketingEventVariableTypeEnum";

const CompareModule = {};

CompareModule.List = class
{
    isLazyInit = false;

    /**
     * @var {CompareModule.ListProductSet}
     */
    productSet;

    /**
     * @var {CompareModule.CounterTracker}
     */
    counterTracker;

    /**
     * @param {bool} isLazyInit 
     */
    constructor(isLazyInit = false) {
        let self = this;
        self.isLazyInit = isLazyInit;
        if (self.isLazyInit === false) {
            self.initComponent();
        }
    }

    initComponent() {

        let self = this;
        self.productSet = new CompareModule.ListProductSet();
        self.counterTracker = new CompareModule.CounterTracker(
            self
        );

        let rawCart = Cookies.get('compare') ? JSON.parse(Cookies.get('compare')) : [];
        self.fillElements(rawCart);

    }

    updateCounterTracker() {
        this.counterTracker.update();
    }

    /**
     * @param {array} rawElements 
     */
    fillElements(rawElements) {

        let self = this;

        // clear old values
        self.productSet.products = [];

        for (let key in rawElements) {
            switch (rawElements[key].productTypeId) {
                case ProductTypeEnum.card:
                    self.productSet.products.push(
                        new CompareModule.CardCartProduct(
                            rawElements[key]
                        )
                    );
                break;
                case ProductTypeEnum.realModifier:
                    self.productSet.products.push(
                        new CompareModule.RealModifierCartProduct(
                            rawElements[key]
                        )
                    );
                break;
            }
        }
    }

    /**
     * @param {int} productTypeId 
     * @param {int} id
     * @param {int|null} virtualModifierId 
     */
    addOrChange(
        productTypeId,
        id,
        virtualModifierId = null,
        callback= null,
    )
    {
        let self = this;

        const isAdd = !self.productSet.products.some(p => {
            const sameType = Number(p.productTypeId) === Number(productTypeId);
            const sameId = Number(p.id) === Number(id);
            return sameType && sameId;
        });
        ProductFetcher.fetchByType({
            productType: productTypeId,
            id: id
        }).then((product) => {
            if(isAdd) {
                // если добавляем в вишлист
                // запускаем маркетинговое событие.
                biMarketingEventRunnerRun({
                    eventTypeId: MarketingEventTypeEnum.addToCompare,
                    dynamicData: {
                        [MarketingEventVariableTypeEnum.currency]: product.currency,
                        [MarketingEventVariableTypeEnum.value]: product.salePrice?.value,
                        [MarketingEventVariableTypeEnum.marketingProductId]: product.marketingProductId,
                        [MarketingEventVariableTypeEnum.productName]: product.title,
                        [MarketingEventVariableTypeEnum.productPrice]: product.salePrice?.value,
                        // зачем кол-во ? ну ладно.
                        [MarketingEventVariableTypeEnum.quantity]: 1,
                    }
                });
            }
        });

        let data = {
            'productTypeId': productTypeId,
            'id': id,
            'virtualModifierId': virtualModifierId,
        };
        data[CsrfToken.name] = CsrfToken.value;

        $.post({
            url: '/compare/add',
            data: data,
            success: function(rawElements) {
                self.fillElements(rawElements);
                self.counterTracker.update();
                if (typeof callback === 'function') {
                    callback();
                }
            },
            error: function(xhr, status, error) {
                console.error("Error occurred: " + status + ", " + error);
            }
        })
    }

    /**
     * @return {int}
     */
    getSummaryCount() {
        return this.productSet.getSummaryCount();
    }

    getProductSet() {
        return this.productSet;
    }

}

CompareModule.CounterTracker = class {

    /**
     * @var {CompareModule.List}
     */
    list;

    trackerSelector = [
        {
            counterSelector: '.site-header__indicators-link.main-compare .site-header__indicators-count span',
            wrapSelector: '.site-header__indicators-link.main-compare .site-header__indicators-count'
        }
    ];

    constructor(list) {
        let self = this;
        self.list = list;
    }

    update() {
        let self = this;
        for (let key in self.trackerSelector) {
            let counterSelector = self.trackerSelector[key].counterSelector;
            let wrapSelector = self.trackerSelector[key].wrapSelector;
            if (self.list.getSummaryCount() > 0) {
                $(wrapSelector).removeClass('hidden');
                $(counterSelector).empty().html(self.list.getSummaryCount());
            } else {
                $(wrapSelector).addClass('hidden');
            }
        }
    }
}

CompareModule.ListProductSet = class {

    /**
     * @var {(CompareModule.CardCartProduct|CompareModule.RealModifierCartProduct)[]}
     */
    products = [];
    
    /**
     * @return {int}
     */
    getSummaryCount() {
        return this.products.length;
    }

}

CompareModule.BaseCartProduct = class {
    id;
    productTypeId;
}

CompareModule.CardCartProduct = class {
    productTypeId = ProductTypeEnum.card;
    
    constructor(cartElement) {
        let self = this;
        self.id = cartElement.id;
    }
}

CompareModule.RealModifierCartProduct = class {

    productTypeId = ProductTypeEnum.realModifier;

    /**
     * @var {CompareModule.VirtualModifierCartProduct|null}
     */
    virtualModifier = null;

    constructor(cartElement) {
        let self = this;
        self.id = cartElement.id;
        if (cartElement.virtualModifierId) {
            self.virtualModifier = new CompareModule.VirtualModifierCartProduct({
                id: cartElement.virtualModifierId
            });
        }
    }
}

CompareModule.VirtualModifierCartProduct = class {
    productTypeId = ProductTypeEnum.virtualModifier;

    constructor(cartElement) {
        let self = this;
        self.id = cartElement.id;
    }
}

CompareModule.list = new CompareModule.List();

export {
    CompareModule
};